var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-flyline-chart-enhanced',{staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }